import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui";
import { Edit, Trash2, ExternalLink } from "lucide-react";
import { useOpenHelpCenter } from "../../../hooks/useOpenHelpCenter";
import type { HelpCenter } from "../../../types";

interface HelpCenterRowProps {
  helpCenter: HelpCenter;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  formatDate: (dateString: string) => string;
}

export const HelpCenterRow: React.FC<HelpCenterRowProps> = ({
  helpCenter,
  onEdit,
  onDelete,
  formatDate,
}) => {
  const { t } = useTranslation();
  const { openHelpCenter } = useOpenHelpCenter();

  const handleOpenPortal = (e: React.MouseEvent) => {
    e.stopPropagation();
    openHelpCenter(helpCenter.slug);
  };

  return (
    <tr className="border-b hover:bg-muted/50 transition-colors">
      <td className="py-2 px-2">
        <Link
          to={`/help-centers/${helpCenter.id}/structure`}
          className="text-left hover:underline cursor-pointer font-medium text-foreground text-sm"
        >
          {helpCenter.title}
        </Link>
      </td>
      <td className="py-2 px-2">
        <code className="text-xs bg-muted px-2 py-1 rounded">
          {helpCenter.slug}
        </code>
      </td>
      <td className="py-2 px-2">
        <div className="text-sm text-muted-foreground">
          {formatDate(helpCenter.updated_at)}
        </div>
      </td>
      <td className="py-2 px-2">
        <div className="flex items-center justify-end gap-1">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleOpenPortal}
            className="h-8 w-8 p-0"
            title={t("helpCenter.row.openPortalTooltip")}
          >
            <ExternalLink className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onEdit(helpCenter.id)}
            className="h-8 w-8 p-0"
          >
            <Edit className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onDelete(helpCenter.id)}
            className="h-8 w-8 p-0 text-destructive hover:text-destructive"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </td>
    </tr>
  );
};
